module.exports = __webpack_public_path__ + "static/img/9.a58e4d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/9.png
// module id = Mo2J
// module chunks = 0